import { createColumnHelper, Table, Text } from '@workwhile/ui'
import { useVndlyTimesheetContext } from '../../context/VndlyTimesheetProvider'

type TimesheetIssueRow = ReturnType<
  typeof useVndlyTimesheetContext
>['state']['issuesState']['workOrderAssociationIssues'][number]

type TimesheetIssueCode = TimesheetIssueRow['issues'][number]

const ISSUE_LABELS: Record<TimesheetIssueCode, string> = {
  work_order_not_found: 'Work order not found',
}

const columnHelper = createColumnHelper<TimesheetIssueRow>()

const columns = [
  columnHelper.accessor('companyName', {
    header: 'Company',
    cell: (info) => <Text>{info.getValue()}</Text>,
  }),
  columnHelper.accessor('positionName', {
    header: 'Position',
    cell: (info) => <Text>{info.getValue()}</Text>,
  }),
  columnHelper.accessor('vndlyJobTitle', {
    header: 'VNDLY Job Title',
    cell: (info) => <Text>{info.getValue() ?? '-'}</Text>,
  }),
  columnHelper.accessor('workerName', {
    header: 'Worker',
    cell: (info) => <Text>{info.getValue()}</Text>,
  }),
  columnHelper.accessor('vndlyCandidateUniqueId', {
    header: 'Candidate Unique ID',
    cell: (info) => <Text>{info.getValue() ?? '-'}</Text>,
  }),
  columnHelper.accessor('issues', {
    header: 'Issue',
    cell: (info) => (
      <Text>
        {info
          .getValue()
          .map((issue) => ISSUE_LABELS?.[issue] ?? issue)
          .join(', ')}
      </Text>
    ),
  }),
]

export function TimesheetIssuesTable() {
  const {
    state: {
      issuesState: { workOrderAssociationIssues },
    },
  } = useVndlyTimesheetContext()

  return <Table columns={columns} data={workOrderAssociationIssues} />
}
